(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalogues"] && !Shopify.designMode) return;
  try {
    
  class CataloguesList extends HTMLElement {
    connectedCallback() {
      this.searchInput = this.querySelector('[data-catalogues-search]');
      this.categoryButtons = this.querySelectorAll('.catalogues__category');
      this.items = Array.from(this.querySelectorAll('[data-catalogues-item]'));
      this.shownCounter = this.querySelector('[data-catalogues-shown]');
      this.emptyState = this.querySelector('[data-catalogues-empty]');
      this.activeCategory = '';
      this.query = '';
      this.fuse = null;

      this.fuseRecords = this.items.map((item, i) => ({
        index: i,
        title: item.dataset.title || '',
        category: item.dataset.cat || '',
        description: item.dataset.desc || ''
      }));

      if (window.Fuse) {
        this.fuse = new window.Fuse(this.fuseRecords, {
          threshold: 0.35,
          ignoreLocation: true,
          keys: [
            { name: 'title', weight: 3 },
            { name: 'category', weight: 1 },
            { name: 'description', weight: 1 }
          ]
        });
      }

      if (this.searchInput) {
        this.searchInput.addEventListener('input', (e) => {
          this.query = e.target.value.trim();
          this.applyFilters();
        });
      }

      this.categoryButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.activeCategory = btn.dataset.category || '';
          this.categoryButtons.forEach((b) => {
            const active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.applyFilters();
        });
      });
    }

    applyFilters() {
      const query = this.query;
      let matchMap = null;

      if (query) {
        matchMap = new Map();
        if (this.fuse) {
          this.fuse.search(query).forEach((result) => {
            matchMap.set(result.item.index, true);
          });
        } else {
          // Fuse not yet loaded — fall back to case-insensitive indexOf
          const q = query.toLowerCase();
          this.items.forEach((item, i) => {
            const haystack = [item.dataset.title, item.dataset.cat, item.dataset.desc]
              .join(' ').toLowerCase();
            if (haystack.indexOf(q) !== -1) matchMap.set(i, []);
          });
        }
      }

      let shown = 0;
      this.items.forEach((item, i) => {
        const cat = item.dataset.category || '';
        const categoryMatch = !this.activeCategory || cat === this.activeCategory;
        const searchMatch = matchMap === null || matchMap.has(i);
        const visible = categoryMatch && searchMatch;
        item.hidden = !visible;
        if (visible) shown++;
      });

      if (this.shownCounter) this.shownCounter.textContent = shown;
      if (this.emptyState) this.emptyState.hidden = shown !== 0;
    }
  }

  if (!customElements.get('catalogues-list')) {
    customElements.define('catalogues-list', CataloguesList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manuals"] && !Shopify.designMode) return;
  try {
    
  class ManualsList extends HTMLElement {
    connectedCallback() {
      this.searchInput = this.querySelector('[data-manuals-search]');
      this.categoryButtons = this.querySelectorAll('.manuals__category');
      this.items = Array.from(this.querySelectorAll('[data-manuals-item]'));
      this.shownCounter = this.querySelector('[data-manuals-shown]');
      this.emptyState = this.querySelector('[data-manuals-empty]');
      this.activeCategory = '';
      this.query = '';
      this.fuse = null;

      this.fuseRecords = this.items.map((item, i) => ({
        index: i,
        title: item.dataset.title || '',
        category: item.dataset.cat || '',
        description: item.dataset.desc || ''
      }));

      if (window.Fuse) {
        this.fuse = new window.Fuse(this.fuseRecords, {
          threshold: 0.35,
          ignoreLocation: true,
          keys: [
            { name: 'title', weight: 3 },
            { name: 'category', weight: 1 },
            { name: 'description', weight: 1 }
          ]
        });
      }

      if (this.searchInput) {
        this.searchInput.addEventListener('input', (e) => {
          this.query = e.target.value.trim();
          this.applyFilters();
        });
      }

      this.categoryButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.activeCategory = btn.dataset.category || '';
          this.categoryButtons.forEach((b) => {
            const active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.applyFilters();
        });
      });
    }

    applyFilters() {
      const query = this.query;
      let matchMap = null;

      if (query) {
        matchMap = new Map();
        if (this.fuse) {
          this.fuse.search(query).forEach((result) => {
            matchMap.set(result.item.index, true);
          });
        } else {
          // Fuse not yet loaded — fall back to case-insensitive indexOf
          const q = query.toLowerCase();
          this.items.forEach((item, i) => {
            const haystack = [item.dataset.title, item.dataset.cat, item.dataset.desc]
              .join(' ').toLowerCase();
            if (haystack.indexOf(q) !== -1) matchMap.set(i, []);
          });
        }
      }

      let shown = 0;
      this.items.forEach((item, i) => {
        const cat = item.dataset.category || '';
        const categoryMatch = !this.activeCategory || cat === this.activeCategory;
        const searchMatch = matchMap === null || matchMap.has(i);
        const visible = categoryMatch && searchMatch;
        item.hidden = !visible;
        if (visible) shown++;
      });

      if (this.shownCounter) this.shownCounter.textContent = shown;
      if (this.emptyState) this.emptyState.hidden = shown !== 0;
    }
  }

  if (!customElements.get('manuals-list')) {
    customElements.define('manuals-list', ManualsList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
